/* eslint-disable no-useless-escape */
import * as Yup from "yup";
// import { isValidPhoneNumber } from "libphonenumber-js";

const MOBILE_REGEX =
  /^\s*(?:\+?(\d{2}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

const PASSWORD_REGEX =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;

// function validateStateCodeByState(state, stateCode) {
//   if (state && stateCode) {
//     const found = states.find((st) => st.value === state);
//     if (Object.values(found).includes(stateCode)) {
//       return true;
//     } else {
//       return false;
//     }
//   } else {
//     return false;
//   }
// }

const validatePassword = (password) => {
  if (
    password.length < 8 ||
    !/[A-Z]/.test(password) ||
    !/[a-z]/.test(password) ||
    !/[0-9]/.test(password) ||
    !/[@#$%^&+*!=]/.test(password)
  ) {
    return false;
  }
  return true;
};

const ID_VALIDATION = (input) => {
  if (input === "0" || input === 0) {
    return false;
  }
  return true;
};

export const createEventManagerValidationSchema = Yup.object({
  firstName: Yup.string().trim().required("First Name is required"),

  employeeId: Yup.string()
    .required("Employee Id is required")
    .test(
      "employeeId",
      "Employee Id should not be zero",
      async function (value) {
        if (value) {
          return ID_VALIDATION(value);
        } else {
          return true;
        }
      },
    ),

  department: Yup.string()
    .trim()

    .required("Department is required"),
  mailId: Yup.string()
    .email("Please enter valid email")
    .required("Email is Required"),

  contactNumber: Yup.string("Please enter valid phone number")
    .matches(MOBILE_REGEX, "Please enter valid phone number")
    .required("Phone number is required"),

  // contactNumber: Yup.string("Please enter valid contact number")
  //   // .matches(MOBILE_REGEX, "Please enter valid phone number")
  //   .required("Contact Number is required")
  //   .test(
  //     "mobile",
  //     "Please enter valid contact number",
  //     async function (value) {
  //       if (!isValidPhoneNumber(String(value), "IN")) {
  //         return false;
  //       } else {
  //         return true;
  //       }
  //     }
  //   ),

  // createModifyOrg: Yup.string()
  //   .trim()
  //   .required("At least one checkbox must be selected"),

  // createModifyHost: Yup.string()
  //   .trim()
  //   .required("Create / Modify / Disable the Host  is required"),
});

export const SignInValidationSchema = Yup.object({
  email: Yup.string()
    .email("Please enter valid email")
    .required("Email is Required"),
  password: Yup.string().required("Password is required"),
  selectUser: Yup.string().trim().required("Role is required"),
});

export const updateEventManagerValidationSchema = Yup.object({
  firstName: Yup.string().trim().required("First Name is required"),

  employeeId: Yup.string()
    .required("Employee Id is required")
    .test(
      "employeeId",
      "Employee Id should not be zero",
      async function (value) {
        if (value) {
          return ID_VALIDATION(value);
        } else {
          return true;
        }
      },
    ),
  // .matches(/^[^0]*$/, "Employee Id should not be zero"),

  department: Yup.string()
    .trim()

    .required("Department is required"),

  // contactNumber: Yup.string("Please enter valid contact number")
  //   // .matches(MOBILE_REGEX, "Please enter valid phone number")
  //   .required("Contact Number is required")
  //   .test(
  //     "mobile",
  //     "Please enter valid contact number",
  //     async function (value) {
  //       if (!isValidPhoneNumber(String(value), "IN")) {
  //         return false;
  //       } else {
  //         return true;
  //       }
  //     }
  //   ),

  contactNumber: Yup.string("Please enter valid phone number")
    .matches(MOBILE_REGEX, "Please enter valid phone number")
    .required("Phone number is required"),

  // checkboxes: Yup.array()
  //   .min(1, "At least one checkbox must be selected")
  //   .required("At least one checkbox must be selected"),
});

export const createOrganisationValidationSchema = Yup.object({
  orgName: Yup.string().trim().required("Organisation Name is required"),
  contactName: Yup.string().trim().required("Contact Name is required"),
  designation: Yup.string().trim().required("Designation is required"),

  // contactNumber: Yup.string("Please enter valid contact number")
  //   // .matches(MOBILE_REGEX, "Please enter valid phone number")
  //   .required("Official Contact Number is required")
  //   .test(
  //     "mobile",
  //     "Please enter valid contact number",
  //     async function (value) {
  //       if (!isValidPhoneNumber(String(value), "IN")) {
  //         return false;
  //       } else {
  //         return true;
  //       }
  //     }
  //   ),

  contactNumber: Yup.string("Please enter valid phone number")
    .matches(MOBILE_REGEX, "Please enter valid phone number")
    .required("Phone number is required"),

  mailId: Yup.string()
    .email("Please enter valid email")
    .required("Official Mail ID is required"),

  country: Yup.string().trim().required("Country is required"),

  state: Yup.string().trim().required("State is required"),

  city: Yup.string().trim().required("City is required"),

  registeredAddress: Yup.string()
    .trim()
    .required("Registered Address is required"),

  // officeAddress: Yup.string().trim().required("Office Address is required"),

  stateCode: Yup.string().trim().required("stateCode is required"),

  // stateCode: Yup.string()
  //   .required("stateCode is required")
  //   .test("stateCode", "Invalid State Code", async function (value) {
  //     if (value) {
  //       return validateStateCodeByState(this.parent.state, value);
  //     } else {
  //       return false;
  //     }
  //   }),

  billingAddressOpt: Yup.string()
    .trim()
    .required("Billing Address is required"),
});

export const profiletionValidationSchema = Yup.object({
  employeeId: Yup.string().trim().required("Employee ID is required"),

  firstName: Yup.string().trim().required("First Name is required"),

  // contactNumber: Yup.string().trim().required("First Name is required"),

  contactNumber: Yup.string("Please enter valid phone number")
    .matches(MOBILE_REGEX, "Please enter valid phone number")
    .required("Phone number is required"),

  mailId: Yup.string()
    .email("Please enter valid email")
    .required("Official Mail ID is required"),
});

export const changePasswordSchema = Yup.object({
  oldPassword: Yup.string()
    .min(6, "Please enter 6 characters")
    .required("Current Password is required"),
  newPassword: Yup.string()
    .matches(
      PASSWORD_REGEX,
      "Password should have a minimum of 8 characters and 1 uppercase and 1 numeral and 1 special character",
    )
    .min(6, "Please enter 8 characters")
    .required("New Password is required"),
  confirmPassword: Yup.string()
    .required("Confirm New Password is required")
    .min(6, "Password must be minimum 8 characters")
    .test("passwords-match", "Passwords do not match", function (value) {
      return this.parent.newPassword === value;
    }),
});

export const hostValidationSchema = Yup.object({
  orgId: Yup.string().trim().required("Organisation Name ID is required"),

  firstName: Yup.string().trim().required("First Name is required"),

  // contactNumber: Yup.string().trim().required("First Name is required"),

  contactNumber: Yup.string("Please enter valid phone number")
    .matches(MOBILE_REGEX, "Please enter valid phone number")
    .required("Contact Number is required"),

  mailId: Yup.string()
    .email("Please enter valid email")
    .required("Official Mail ID is required"),
});

// const RADIO_VALIDATION = (input) => {
//   if (input === "0" || input === 0) {
//     return false;
//   }
//   return true;
// };

export const createEventsValidationSchema = Yup.object({
  organization: Yup.string().trim().required("Organisation is required"),
  eventName: Yup.string().trim().required("Events Name is required"),
  date: Yup.string().nullable().trim().required("Date is required"),
  mappedHost: Yup.string().trim().required("Add host is required"),
  streamingDestination: Yup.string()
    .trim()
    .required("Streaming Destination is required"),

  startTime: Yup.string().nullable().trim().required("Start Time is mandatory"),

  endTime: Yup.string()
    .nullable()
    .trim()
    .required("End time is required")
    .test(
      "endTime",
      "End time must be greater than start time",
      function (value) {
        const { startTime } = this.parent;
        if (startTime && value) {
          return new Date(value) > new Date(startTime);
        }
        return true;
      },
    ),

  // endTime: Yup.string().nullable().trim().required("End Time is mandatory"),

  streamingUrl: Yup.string().trim().required("Streaming Url is required"),

  // enableQa: Yup.string()
  //   .nullable()
  //   .trim()
  //   .required("Q and A Address is required")
  //   .test("enableQa", "Q and A Address is required", async function (value) {
  //     if (value) {
  //       return RADIO_VALIDATION(value);
  //     } else {
  //       return true;
  //     }
  //   }),
});

export const ViewerSignInValidationSchema = Yup.object({
  emailId: Yup.string()
    .email("Please enter valid email")
    .required("Email is Required"),
  name: Yup.string().required("First Name is required"),
});

export const ViewerRegisterSignInValidationSchema = Yup.object({
  emailId: Yup.string()
    .email("Please enter valid email")
    .required("Email is Required"),
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  contactNumber: Yup.string("Please enter valid phone number")
    .matches(MOBILE_REGEX, "Please enter valid phone number")
    .required("Phone number is required"),
  employeeId: Yup.string()
    .required("Employee Id is required")
    .test(
      "employeeId",
      "Employee Id should not be zero",
      async function (value) {
        if (value) {
          return ID_VALIDATION(value);
        } else {
          return true;
        }
      },
    ),
  password: Yup.string().required("Password is required"),
});

export const PriorRegisterEventValidationSchema = Yup.object({
  emailId: Yup.string()
    .email("Please enter valid email")
    .required("Email is Required"),
  name: Yup.string().required("Name is required"),
});

export const PriorSignInValidationSchema = Yup.object({
  emailId: Yup.string()
    .email("Please enter valid email")
    .required("Email is Required"),
  name: Yup.string().required("Name is required"),
});

export const ResetPasswordSchema = Yup.object({
  password: Yup.string()
    .required("Password is required")
    .min(6, "Please enter 8 characters")
    .test(
      "password",
      "Password should have a minimum of 8 characters and 1 uppercase and 1 numeral and 1 special character",
      async function (value) {
        if (value?.toString()?.length) {
          return validatePassword(value);
        } else {
          return false;
        }
      },
    ),
  // password: Yup.string()
  //   .matches(
  //     PASSWORD_RULE,
  //     "Password should have a minimum of 1 digit and 1 letter"
  //   )
  //   .min(6, "Please enter 6 characters")
  //   .required("Password is required"),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .test("passwords-match", "Passwords do not match", function (value) {
      return this.parent.password === value;
    }),
});

export const hostProfiletionValidationSchema = Yup.object({
  firstName: Yup.string().trim().required("First Name is required"),

  // contactNumber: Yup.string().trim().required("First Name is required"),

  // contactNumber: Yup.string("Please enter valid phone number")
  //   .matches(MOBILE_REGEX, "Please enter valid phone number")
  //   .required("Phone number is required"),

  mailId: Yup.string()
    .email("Please enter valid email")
    .required("Official Mail ID is required"),
});

/**
 * @description Digital Event new
 */

export const generalValidationSchema = Yup.object({
  eventName: Yup.string().trim().required("Event Name is required"),
  eventTemplate: Yup.string().trim().required("Event template is required"),
  eventTime: Yup.string().trim().required("Event time is required"),
  eventDate: Yup.string().trim().required("Event date is required"),
  eventStatus: Yup.string().trim().required("Event status is required"),
  eventTitle: Yup.string().trim().required("Event title is required"),
  // registrationStatus: Yup.string()
  //   .trim()
  //   .required("Registration status is required"),
  eventDuration: Yup.string()
    .trim()
    .required("Duration is required")
    .matches(
      /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
      "Invalid time format (HH:MM)",
    ),
  orgId: Yup.string().trim().required("Organisation is required"),
  mappedHost: Yup.array().when("orgId", {
    is: (orgId) => Boolean(orgId && orgId.trim() !== ""), // Ensures orgId is not empty
    then: (schema) =>
      schema
        .min(1, "Mapped Host cannot be an empty array")
        .required("Mapped Host is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  // coordinatorInfo: Yup.object().shape({
  //   coordinatorName: Yup.string().required("Coordinator name is required"),
  //   coordinatorphone: Yup.string().required("Coordinator phone is required"),
  //   coordinatorEmail: Yup.string().required("Coordinator email is required"),
  //   coordinatorLocation: Yup.string().required(
  //     "Coordinator location is required",
  //   ),
  // }),
  // advanceOptions: Yup.object().shape({
  //   micrositePrefix: Yup.string().required(
  //     "Micro site prefix name is required",
  //   ),
  //   copyrightText: Yup.string().required(" Copy right is required"),
  //   websiteAddress: Yup.string().required("Website address is required"),
  // }),
});

export const formsValidationSchema = Yup.object().shape({
  standardField: Yup.object()
    .shape({
      preValidateLabel: Yup.string().trim(),
      emailId: Yup.string().when("preValidateLabel", {
        is: "emailId",
        then: (schema) => schema.required("Email address is required").trim(),
        otherwise: (schema) => schema.notRequired(),
      }),
      phoneNumber: Yup.string().when("preValidateLabel", {
        is: "mobile",
        then: (schema) => schema.required("Phone number is required").trim(),
        otherwise: (schema) => schema.notRequired(),
      }),
    })
    .test(
      "email-or-phone-required",
      "At least one of Email or Phone Number is required",
      function (values) {
        const {
          preValidateLabel,
          emailId,
          phoneNumber,
          preValidateRegistration,
        } = values;

        // Convert "true"/"false" strings to actual booleans
        const emailValue =
          emailId === "true" ? true : emailId === "false" ? false : emailId;
        const phoneValue =
          phoneNumber === "true"
            ? true
            : phoneNumber === "false"
            ? false
            : phoneNumber;

        // If preValidateLabel is "emailId", then emailId must be provided.
        if (
          preValidateLabel === "emailId" &&
          !emailValue &&
          preValidateRegistration
        ) {
          return this.createError({
            path: "emailId",
            message: "Email address is required",
          });
        }

        // If preValidateLabel is "mobile", then phoneNumber must be provided.
        if (
          preValidateLabel === "mobile" &&
          !phoneValue &&
          preValidateRegistration
        ) {
          return this.createError({
            path: "phoneNumber",
            message: "Phone number is required",
          });
        }

        // If preValidateLabel is neither "emailId" nor "mobile", at least one should be present.
        // if (emailValue !== true || phoneValue !== true) {
        //   return this.createError({
        //     path: "standardField", // Assign error to a relevant field
        //     message: "At least one of Email or Phone Number is required",
        //   });
        // }
        if (!preValidateRegistration && !emailValue && !phoneValue) {
          return this.createError({
            path: "standardField", // Assign error to a relevant field
            message: "At least one of Email or Phone Number is required",
          });
        }

        return true; // If all conditions pass, validation succeeds
      },
    ),
});

export const resorcesValidationSchema = Yup.object().shape({
  items: Yup.array().of(
    Yup.object().shape({
      resourceType: Yup.string().required("Resource Type is required"),
      linkUrl: Yup.string().when("resourceType", {
        is: "hyperLink",
        then: (schema) =>
          schema.url("Must be a valid URL").required("Link URL is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      uploadVideo: Yup.string().when("resourceType", {
        is: (value) => value === "video" || value === "document",
        then: (schema) => schema.required("Upload Video is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
  ),
});

export const additionalTabValidationSchema = Yup.object().shape({
  items: Yup.array().of(
    Yup.object().shape({
      tabTitle: Yup.string().trim(),
      tabUrl: Yup.string().when("tabTitle", {
        is: (value) => value,
        then: (schema) =>
          schema
            .url("Must be a valid URL")
            .required("Tab url Video is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
  ),
});

export const userAccessValidationSchema = Yup.object().shape({
  eventSettings: Yup.object().shape({
    eventTemplate: Yup.string().trim(),
    commonPassword: Yup.boolean(),
    enableRegistration: Yup.boolean().required(),
    enableLogins: Yup.boolean().required(),
    commonPasswordEntry: Yup.string().when("commonPassword", {
      is: true,
      then: (schema) => schema.required("Common Password Entry is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    atLeastOneSelected: Yup.mixed().test(
      "at-least-one",
      "At least one of Registration or Logins must be selected",
      function () {
        const { eventTemplate } = this.parent;
        const enableRegistration = this.resolve(Yup.ref("enableRegistration"));
        const enableLogins = this.resolve(Yup.ref("enableLogins"));

        // If eventTemplate is "AGM", skip validation
        if (eventTemplate === "AGM") {
          return true;
        }
        // Otherwise, validate that at least one of them is selected
        return Boolean(enableRegistration || enableLogins);
      },
    ),
  }),
  preValidateUsers: Yup.object().shape({
    preValidateRegistration: Yup.boolean(),
    preValidateLabel: Yup.string().when("preValidateRegistration", {
      is: true,
      then: (schema) => schema.required("PreValidate Label is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),
  preValidateUserList: Yup.array().when(
    "preValidateUsers.preValidateRegistration",
    {
      is: true,
      then: (schema) =>
        schema
          .min(1, "At least one user is required")
          .required("User list is required"),
      otherwise: (schema) => schema.notRequired(),
    },
  ),
  forceReferrer: Yup.object().shape({
    forceReferrerCheck: Yup.boolean(),
    referrerCheckUrl: Yup.string().when("forceReferrerCheck", {
      is: true,
      then: (schema) => schema.required("Resources visibility is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),
});

export const copyTemplateValidationSchema = Yup.object({
  eventName: Yup.string().trim().required("Event Name is required"),
  eventDate: Yup.string().trim().required("Event Date is required"),
  eventTime: Yup.string().trim().required("Event Time is required"),
  copyReason: Yup.string().trim().required("Reason is required"),
});

export const reasonForCancelValidationSchema = Yup.object({
  reasonForEvent: Yup.string().trim().required("Reason is required"),
});

export const eventSettingsValidationSchema = Yup.object().shape({
  livePageSettings: Yup.object().shape({
    contentFormat: Yup.string().trim().required("Content format is required"),
  }),
  galleryView: Yup.object().shape({
    phoneNumber: Yup.boolean(),
    emailId: Yup.boolean(),
    eventTemplate: Yup.string().trim(),
    atLeastOneSelected: Yup.mixed().test(
      "at-least-one",
      "At least one of Phone number or Email id must be selected",
      function () {
        const { eventTemplate } = this.parent;
        const emailId = this.resolve(Yup.ref("emailId"));
        const phoneNumber = this.resolve(Yup.ref("phoneNumber"));

        // If eventTemplate is "AGM", skip validation
        if (eventTemplate === "AGM") {
          return Boolean(emailId || phoneNumber);
        }
        return true;
      },
    ),
  }),
});

export const chatModalValidationSchema = Yup.object().shape({
  items: Yup.array().of(
    Yup.object().shape({
      clientId: Yup.string()
        .notRequired()
        .matches(/^\d{2,20}$/, "Must be 2 to 20 digits")
        .nullable(),
    }),
  ),
});

// export const FAQValidationSchema = Yup.object({
//   sections: Yup.array(
//     Yup.object({
//       question: Yup.string().trim().required("Question is mandatory"),
//       answer: Yup.string().trim().required("Answer is mandatory"),
//     }),
//   ),
// });

// export const FAQValidationSchema = Yup.object({
//   sections: Yup.array().of(
//     Yup.object({
//       question: Yup.string().trim(),
//       answer: Yup.string().trim(),
//     })
//   ).test(
//     "last-can-be-empty",
//     "Each entry must have both Question and Answer, except the last one which can be empty",
//     function (sections = []) {
//       const lastIndex = sections.length - 1;
//       return sections.every((item, idx) => {
//         const q = item.question?.trim();
//         const a = item.answer?.trim();
//         const filled = q && a;
//         const empty = !q && !a;
//         return idx === lastIndex ? (filled || empty) : filled;
//       });
//     }
//   )
// });

export const FAQValidationSchema = Yup.object({
  sections: Yup.array()
    // 1) if the last item is fully blank, drop it before validating:
    .transform((sections = []) => {
      if (!Array.isArray(sections) || sections.length === 0) return sections;
      const last = sections[sections.length - 1];
      const q = String(last.question || "").trim();
      const a = String(last.answer  || "").trim();
      if (!q && !a) {
        return sections.slice(0, -1);
      }
      return sections;
    })
    // 2) now every remaining item must have both fields:
    .of(
      Yup.object({
        question: Yup.string()
          .trim()
          .required("Question is mandatory"),
        answer: Yup.string()
          .trim()
          .required("Answer is mandatory"),
      })
    )
});